module.exports = __webpack_public_path__ + "static/media/weather.71878a74.mov";